/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSubtract/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSubtract({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaSubtract",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaSubtract.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-Z1xKbUD': alignSelf,'--mt-2-Z1xKbUD': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1xKbUD': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1xKbUD': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1xKbUD': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1xKbUD': opacity,'--w-10-Z1xKbUD': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1xKbUD': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1xKbUD': fill,'--a-7-Z1xKbUD': isAnimated ? animation : "none",'--sd-8-Z1xKbUD': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1xKbUD': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaSubtract.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 5a5 5 0 015-5h10a5 5 0 015 5v10a5 5 0 01-5 5H5a5 5 0 01-5-5V5zm11.071.714a1.071 1.071 0 10-2.142 0v5H7.143a.714.714 0 00-.505 1.22l2.857 2.857a.715.715 0 001.01 0l2.857-2.857a.714.714 0 00-.505-1.22h-1.786v-5z"
 style={{'--f-12-Z1xKbUD': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}